import type { ReactNode } from "react";
import { FormFieldLockedRegion } from "@patient-watch/ui/form";

/** Inert wrapper for the control area when a template field lock is active. */
export function FormFieldLockedControl({ children, className }: { children: ReactNode; className?: string }) {
    return <FormFieldLockedRegion className={className}>{children}</FormFieldLockedRegion>;
}
